module.exports = __webpack_public_path__ + "static/img/app-logo.7e2eb667.png";